/*
* General app utilities & helpers
*/

import * as _ from 'lodash';

import { Formatters } from './formatters';

export const isNumeric = (n: any) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

export const castNumber = (n: any): number => {
    let result: number = 0;

    if (isNumeric(n)) {
        result = parseFloat(n);
    }

    return result;
};

export const isArrayWithLength = (array) => {
    // Returns true if the array argument is defined and has at least 1 element
    return Boolean(Array.isArray(array) && array.length);
};

export const castArray = (array): Array<any> => {
    if (isArrayWithLength(array)) {
        return array;
    } else {
        return [];
    }
};

export const getArray = (obj, path): Array<any> => {
    return castArray(_.get(obj, path));
};

export const strictExtendMutate = (targetObj: any, sourceObj: any, copyFieldNames: Array<string> = [], mutateTarget: boolean = true) => {
    // COPIES SPECIFIC FIELDS FROM SOURCE TO TARGET, WITH OPTION TO MUTATE TARGET
    // WILL ONLY COPY SPECIFIED FIELDS IN 'copyFieldNames' ARG, OTHERWISE COPIES ALL FIELDS ON SOURCE.

    if (!targetObj || !sourceObj) {
        // console.log('AppUtilities.strictExtendMutate: targetObj or sourceObj arguments missing');
        return {};
    }

    let clonedTargetObj = _.cloneDeep(targetObj);
    let fieldNames: Array<string> = [];

    if (isArrayWithLength(copyFieldNames)) {
        fieldNames = _.cloneDeep(copyFieldNames);
    } else {
        fieldNames = _.keys(sourceObj);
    }

    if (isArrayWithLength(fieldNames)) {
        fieldNames.forEach((k) => {
            if (sourceObj.hasOwnProperty(k)) {
                clonedTargetObj[k] = _.cloneDeep(sourceObj[k]);

                if (mutateTarget) {
                    targetObj[k] = _.cloneDeep(sourceObj[k]);
                }
            }
        });
    }

    return clonedTargetObj;
};

export const generateRandomWords = (
    minWordsCount: number = 5,
    maxWordsCount: number = 10,
    minWordLength: number = 3,
    maxWordLength: number = 10,
    minSentenceWordCount: number = 4,
    maxSentenceWordCount: number = 20,
    vowelChance: number = 30,
    sentenceChance: number = 20,
    addDebug: boolean = true,
) => {
    const numWords = _.random(minWordsCount, maxWordsCount);
    const punctuation = ['.', ';', '?', '!', '...', '?!', '!!!!', ':)'];

    let words = '';
    let sentenceLength = 0;

    let sentenceCount = 1;

    for (let i = 0; i < numWords; i++) {
        let word = generateRandomWord(minWordLength, maxWordLength, vowelChance);

        if (sentenceLength === 0) { word = _.capitalize(word); }

        if (i !== 0) { word = ` ${word}`; }

        if ((sentenceLength > maxSentenceWordCount) ||
            ((sentenceLength >= minSentenceWordCount) && (_.random(1, 100) <= sentenceChance))) {
            word += _.sample(punctuation);
            sentenceLength = 0;
            sentenceCount++;
        }

        words += word;
        sentenceLength++;
    }

    words += _.sample(punctuation);

    if (addDebug) {
        return `Generated ${Formatters.plural('word', numWords, true)} in ${Formatters.plural('sentence', sentenceCount, true)}` + _.sample(punctuation) + ` ${words}`;
    } else {
        return words;
    }
};

export const generateRandomWord = (minLength: number = 3, maxLength: number = 5, vowelChance: number = 30) => {
    const vowels = ['a', 'e', 'i', 'o', 'u'];
    const consts =  ['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'qu', 'r', 's', 't', 'v', 'w', 'x', 'y', 'z', 'tt', 'ch', 'sh'];

    const wordLength = _.random(minLength, maxLength);

    let word = '';
    let wasVowel = true;

    const getChar = () => {
        if (!wasVowel && _.random(1, 100) <= vowelChance) {
            wasVowel = true;
            return _.sample(vowels);
        }  else {
            wasVowel = false;
            return _.sample(consts);
        }
    };

    for (let i = 0; i < wordLength; i++) { word += getChar(); }

    return word;
};



// WEBPACK FOOTER //
// ./src/common/apputilities.tsx